export const HOST_URL = process.env.REACT_APP_HOST_URL
export const CLASSTING_URL = process.env.REACT_APP_CLASSTING_URL
